import { useMemo } from "react";
import { isString } from "lodash";
import getConnection from "core/shared/util/marvellConnection";
import useGetData from "core/shared/hooks/useGetData";
import ReportsConstants from "reports/utils/ReportsConstants";

const hasNoValue = ["", null, undefined];

const { NO_VALUE, ACTIVE, INACTIVE } = ReportsConstants;
const matchModes = {
  contains: "=~",
  equals: "=",
  gt: ">",
  gte: ">=",
  lt: "<",
  lte: "<=",
  notEquals: "!=",
};

export const filterReducer = (arr, [key, { matchMode, value }]) => {
  if (hasNoValue.includes(value)) return arr;
  const op = matchModes[matchMode];

  if (key === "status") {
    if (value === ReportsConstants.ALL) {
      return arr;
    }

    arr.push({ field: "active", op, value: value === ReportsConstants.ACTIVE });
    return arr;
  }

  if (key === "reportType") {
    if (value === ReportsConstants.ALL) {
      return arr;
    }

    arr.push({ field: "report", op: "=", value });
    return arr;
  }

  if (key === "reportName") {
    arr.push({
      field: "name",
      op,
      value,
    });
    return arr;
  }

  const apiVal = isString(value) ? value.toLowerCase() : value;
  arr.push({ field: key, op, value: apiVal });

  return arr;
};

export const transformSending = ({ filters, signal, sortOrder }) => {
  const transformedFilters = Object.entries(filters).reduce(filterReducer, []);

  return {
    filters: transformedFilters,
    signal,
    sortOrder,
  };
};

export const transformReceiving = (resp) => {
  for (const item of resp?.data || []) {
    const { name, report, active } = item;
    item.reportName = name;
    item.reportType = report || NO_VALUE;
    item.reportStatus = active ? ACTIVE : INACTIVE;
  }

  return resp;
};

const useGetDataExportList = ({ filters, sortOrder, updatedEntities }) => {
  const initial = useMemo(() => [], []);
  const connection = getConnection();

  const { data, loading } = useGetData({
    dataPromise: ({ signal }) => {
      const params = transformSending({
        filters,
        signal,
        sortOrder,
      });

      return connection.getDataExportsList(params) || Promise.resolve(initial);
    },
    dependencies: [filters, sortOrder, updatedEntities],
    getResponseData: transformReceiving,
  });

  return { data: data || initial, loading };
};

export default useGetDataExportList;
